import React from 'react';

interface SEOPreviewCardProps {
  title: string;
  description: string;
  url: string;
  image?: string;
  type?: 'google' | 'facebook' | 'twitter' | 'all';
}

const SEOPreviewCard: React.FC<SEOPreviewCardProps> = ({
  title,
  description,
  url,
  image,
  type = 'all'
}) => {
  const titleLength = title.length;
  const descriptionLength = description.length;
  const titleStatus = titleLength >= 50 && titleLength <= 60 ? 'good' : titleLength < 50 ? 'short' : 'long';
  const descriptionStatus = descriptionLength >= 150 && descriptionLength <= 160 ? 'good' : descriptionLength < 150 ? 'short' : 'long';

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'good': return '#16a34a';
      case 'short': return '#f59e0b';
      case 'long': return '#dc2626';
      default: return '#666';
    }
  };

  const renderGooglePreview = () => (
    <div className="seo-preview-card google-preview">
      <div className="preview-header">
        <h4>Google Search Result</h4>
        <div className="character-counts">
          <span style={{ color: getStatusColor(titleStatus) }}>
            Title: {titleLength}/60 {titleStatus === 'good' ? '✓' : titleStatus === 'short' ? '⚠' : '✗'}
          </span>
          <span style={{ color: getStatusColor(descriptionStatus) }}>
            Description: {descriptionLength}/160 {descriptionStatus === 'good' ? '✓' : descriptionStatus === 'short' ? '⚠' : '✗'}
          </span>
        </div>
      </div>
      <div className="google-result">
        <div className="google-url">{url.replace(/^https?:\/\//, '').split('/')[0]}</div>
        <div className="google-title" style={{ color: '#1a0dab' }}>{title}</div>
        <div className="google-description" style={{ color: '#4d5156' }}>{description}</div>
      </div>
    </div>
  );

  const renderFacebookPreview = () => (
    <div className="seo-preview-card facebook-preview">
      <div className="preview-header">
        <h4>Facebook Share Preview</h4>
      </div>
      <div className="facebook-card">
        {image && (
          <div className="facebook-image">
            <img src={image} alt={title} />
          </div>
        )}
        <div className="facebook-content">
          <div className="facebook-url">{url.replace(/^https?:\/\//, '').split('/')[0]}</div>
          <div className="facebook-title">{title}</div>
          <div className="facebook-description">{description}</div>
        </div>
      </div>
    </div>
  );

  const renderTwitterPreview = () => (
    <div className="seo-preview-card twitter-preview">
      <div className="preview-header">
        <h4>Twitter Card Preview</h4>
      </div>
      <div className="twitter-card">
        {image && (
          <div className="twitter-image">
            <img src={image} alt={title} />
          </div>
        )}
        <div className="twitter-content">
          <div className="twitter-site">@carmenlorraine</div>
          <div className="twitter-title">{title}</div>
          <div className="twitter-description">{description}</div>
        </div>
      </div>
    </div>
  );

  if (type === 'google') return renderGooglePreview();
  if (type === 'facebook') return renderFacebookPreview();
  if (type === 'twitter') return renderTwitterPreview();

  return (
    <div className="seo-preview-cards-container">
      {renderGooglePreview()}
      {renderFacebookPreview()}
      {renderTwitterPreview()}
    </div>
  );
};

export default SEOPreviewCard;

